import { render } from "./NoRecommendationsPage.vue?vue&type=template&id=43f3fe2c&scoped=true"
import script from "./NoRecommendationsPage.vue?vue&type=script&lang=js"
export * from "./NoRecommendationsPage.vue?vue&type=script&lang=js"

import "./NoRecommendationsPage.vue?vue&type=style&index=0&id=43f3fe2c&lang=scss&scoped=true"

import exportComponent from "../../../MemberPortal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f3fe2c"]])

export default __exports__